// 电子保函 -> 开函申请
import request from "../../request.js";
let bhNgs = "/baohanNGS";

// 查询开函列表
export const getSelectBhList = function(data) {
  return request({
    url: bhNgs + "/selectBhList",
    method: "post",
    requestConfig: {
      hideLoading: true,
    },
    data,
  });
};

// 查询开函申请信息
export const getSelectApplyInfo = function(data) {
  return request({
    url: bhNgs + "/selectApplyInfo",
    method: "post",
    requestConfig: {
      hideLoading: true,
    },
    data,
  });
};

// 查询保函基本信息
export const getSelectBaseInfo = function(data) {
  return request({
    url: bhNgs + "/selectBaseInfo",
    method: "post",
    requestConfig: {
      hideLoading: true,
    },
    data,
  });
};

// 查询撤保基本信息
export const getSelectBhRevocation = function(data) {
  return request({
    url: bhNgs + "/selectBhRevocation",
    method: "post",
    requestConfig: {
      hideLoading: true,
    },
    data,
  });
};
